import CLanguageHandler from '../../../../../NonReact/Languages/LanguageHandler'
import { Validation } from '../Types/Types'
import { ValidateResult } from '../../../../../Vendor/react-hook-form'
import { Rules } from '../../../../../React/Common/Rules/Rules'
import { isVarNotEmpty } from '../../../../../NonReact/utils/GlobalFunctions'

export type ValidateMap = {
    [K in keyof Validation]?: (value: string) => ValidateResult
}

export const buildValidation = (
    validation: Nullable<Validation>,
    language: CLanguageHandler,
    languageKeyPrefix?: string
): ValidateMap => {
    const mappedValidation: ValidateMap = {}

    if (isVarNotEmpty(validation?.required)) {
        mappedValidation.required = Rules.required(language, languageKeyPrefix)
    }

    if (isVarNotEmpty(validation?.minLength)) {
        mappedValidation.minLength = Rules.minLength(language, languageKeyPrefix, validation.minLength)
    }

    if (isVarNotEmpty(validation?.maxLength)) {
        mappedValidation.maxLength = Rules.maxLength(language, languageKeyPrefix, validation.maxLength)
    }

    if (isVarNotEmpty(validation?.pattern)) {
        mappedValidation.pattern = Rules.pattern(language, languageKeyPrefix, validation.pattern)
    }

    if (isVarNotEmpty(validation?.maxWordLength)) {
        mappedValidation.maxWordLength = Rules.maxWordLength(language, languageKeyPrefix, validation.maxWordLength)
    }

    return mappedValidation
}
